import { SelectedPaymentMethodDetails } from '@wix/premium-purchase-checkout-form';
import { CheckoutProps } from '@wix/checkout-components';
import { CheckoutActions, useCheckoutStore } from '../../../../providers';

const SEPA = 'sepa';

export function useSelectedPaymentMethod(): CheckoutProps['selectedPaymentMethod'] {
  const { dispatch } = useCheckoutStore();
  return async ({ selectedPaymentMethod }: SelectedPaymentMethodDetails) => {
    dispatch(
      CheckoutActions.setShowCustomFooter(selectedPaymentMethod !== SEPA),
    );
  };
}
